import React from 'react';
import styled from 'styled-components';

import {
  COLORS,
  GRID,
  FONT_SIZES,
  FONT_FAMILES,
  BREAKPOINTS,
  MELOGO,
  CONTAINERS
} from './styles';

import Header from './components/Header';
import MainContent from './components/MainContent';
import Footer from './components/Footer';

// Container Styles
export const Container = styled.div`
  max-width: 100%;
  margin: auto;

  @media (min-width: ${BREAKPOINTS.medium}px) {
    max-width: ${CONTAINERS.medium}px;
  }

  @media (min-width: ${BREAKPOINTS.large}px) {
    max-width: ${CONTAINERS.large}px;
  }
`;

// Header Styles
export const HeaderContainer = styled.header``;

export const TitleContainer = styled.div`
  padding: ${GRID[4]}px ${GRID[1]}px;
  padding-bottom: ${(MELOGO.small / 2) + (MELOGO.borderSmall * 2)}px;
  background-color: ${COLORS.primary};
  text-align: center;

  @media (min-width: ${BREAKPOINTS.medium}px) {
    padding-bottom: ${(MELOGO.medium / 2) + (MELOGO.borderMedium * 2)}px;
  }
`;

export const Title = styled.h1`
  margin: ${GRID[2]}px auto;
  color: ${COLORS.primaryContrast};
  font-family: ${FONT_FAMILES.secondary};
  font-size: ${FONT_SIZES[4]};

  @media (min-width: ${BREAKPOINTS.medium}px) {
    font-size: ${FONT_SIZES[6]};
  }
`;

export const SubTitle = styled.h2`
  margin: ${GRID[2]}px auto ${GRID[3]}px;
  color: ${COLORS.primaryContrast};
  font-family: ${FONT_FAMILES.secondary};
  font-size: ${FONT_SIZES[3]};

  @media (min-width: ${BREAKPOINTS.medium}px) {
    font-size: ${FONT_SIZES[4]};
  }
`;

// Nav Styles
export const Nav = styled.nav`
  padding: 0 ${GRID[2]}px;
  margin-top: -${(MELOGO.small / 2) + (MELOGO.borderSmall)}px;

  @media (min-width: ${BREAKPOINTS.medium}px) {
    margin-top: -${(MELOGO.medium / 2) + (MELOGO.borderMedium)}px;
  }
`;

export const NavList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 -${GRID[1]}px;
  padding: 0;
  list-style: none;

  @media (min-width: ${BREAKPOINTS.medium}px) {
    align-items: center;
    justify-content: space-around;
  }
`;

export const NavListItemMeLogo = styled.li`
  padding: 0;
  margin: 0;
  order: 0;

  @media (min-width: ${BREAKPOINTS.medium}px) {
    order: 2;
    width: auto;
  }
`;

// MeLogo Styles
export const MeLogo = styled.img`
  display: block;
  width: ${MELOGO.small}px;
  height: ${MELOGO.small}px;
  border: solid ${MELOGO.borderSmall}px ${COLORS.primaryContrast};
  border-radius: 50%;
  background-color: ${COLORS.primaryContrast};

  @media (min-width: ${BREAKPOINTS.medium}px) {
    width: ${MELOGO.medium}px;
    height: ${MELOGO.medium}px;
    border-width: ${MELOGO.borderMedium}px;
  }
`;

// Main Styles
export const MainContainer = styled.main`
  padding: ${GRID[3]}px ${GRID[2]}px ${GRID[3]}px;
  border-radius: 2px;
  background-color: ${COLORS.secondaryContent};

  @media (min-width: ${BREAKPOINTS.medium}px) {
    padding: ${GRID[4]}px ${GRID[3]}px;
  }
`;

// Content Styles
export const Greet = styled.h1`
  font-size: ${FONT_SIZES[3]};
  margin-bottom: ${GRID[2]}px;
`;

export const Describe = styled.h2`
  margin-bottom: ${GRID[1]}px;
  font-size: ${FONT_SIZES[2]};
  font-weight: normal;
`;

// Footer Styles
export const FooterContainer = styled.footer`
  padding: ${GRID[6]}px ${GRID[2]}px;
  text-align: center;
  font-size: 14px;
  background-color: ${COLORS.footer};

  @media (min-width: ${BREAKPOINTS.medium}px) {
    padding: ${GRID[3]}px;
  }

  @media (min-width: ${BREAKPOINTS.large}px) {
    padding: ${GRID[5]}px;
  }
`;

export const Quote = styled.blockquote`
  font-size: 25px;
  max-width: 600px;
    margin: 0 auto;
`;

export const QuoteFooter = styled.footer`
  margin-top: ${GRID[1]}px;
  font-size: 12px;
  opacity: 0.75;
`;

// Main App Component
const App = () => {
  return (
    <div>
      <Header />

      <Container>
        <MainContent />
      </Container>

      <Footer />
    </div>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/app.js